import { render, staticRenderFns } from "./AvatarBox.vue?vue&type=template&id=5d2f3b9a&scoped=true"
import script from "./AvatarBox.vue?vue&type=script&lang=js"
export * from "./AvatarBox.vue?vue&type=script&lang=js"
import style0 from "./AvatarBox.vue?vue&type=style&index=0&id=5d2f3b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f3b9a",
  null
  
)

export default component.exports